import { render, staticRenderFns } from "./MaxLengthEditor.vue?vue&type=template&id=cf0cab06&scoped=true"
import script from "./MaxLengthEditor.vue?vue&type=script&lang=js"
export * from "./MaxLengthEditor.vue?vue&type=script&lang=js"
import style0 from "./MaxLengthEditor.vue?vue&type=style&index=0&id=cf0cab06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0cab06",
  null
  
)

export default component.exports